<div class="trustees-container px-4 py-3">
    <!-- Page Header -->
    <div class="mb-3">
      <h2 class="fw-bold mb-1">Employees</h2>
      <p class="text-dark mb-0 d-none">
        Board of employees managing the BEE Trust
      </p>
    </div>

    <!-- Summary Cards -->
    <div class="row g-4 mb-4">
      <!-- Total Trustees -->
      <div class="col-md-6">
        <div class="glassy-table shadow-sm border-0 rounded-lg p-3 h-100">
          <p class="text-dark small mb-2">Total Employees</p>
          <h3 class="fw-bold mb-1">{{ sub_entity_stats.total }}</h3>
          <p class="text-success small mb-0">{{ sub_entity_stats.active }} active</p>
        </div>
      </div>

      <!-- Independent Trustees -->
      <div class="col-md-4 d-none">
        <div class="glassy-table shadow-sm border-0 rounded-lg p-3 h-100">
          <p class="text-dark small mb-2">Independent Contractor</p>
          <h3 class="fw-bold mb-1">1</h3>
          <p class="text-dark small mb-0">As required by company governance policy</p>
        </div>
      </div>

      <!-- Next Meeting -->
      <div class="col-md-6">
        <div class="glassy-table shadow-sm border-0 rounded-lg p-3 h-100">
          <p class="text-dark small mb-2">Next Meeting</p>
          <h3 class="fw-bold mb-1">15 Feb 2026</h3>
          <p class="text-dark small mb-0">Quarterly board meeting</p>
        </div>
      </div>
    </div>

    <!-- Board of Trustees Card -->
    <div class="glassy-table shadow-sm border-0 rounded-lg p-4">

      <div class="mb-4">
        <h4 class="fw-bold mb-1">Current employees</h4>
        <p class="text-dark small mb-0 d-none">
          Current employees
        </p>
      </div>

      <!-- Table Header -->
      <div class="row text-dark text-xs fw-semibold border-bottom border-dark pb-2 mb-3">
        <div class="col-md-5">Employee Name</div>
        <div class="col-md-4">Sub Category Type</div>
        <div class="col-md-3">Date Added</div>
      </div>

      <!-- Empty state -->
      <div v-if="!is_loading_trustees && !trustees.length" class="text-center text-muted py-3">
        <i class="bi bi-person-x fs-4 mb-2 d-block"></i>
        No employees found
      </div>

      <!-- Trustee Rows -->
      <div
        v-else
        v-for="trustee in trustees"
        :key="trustee.id"
        class="row align-items-center py-3 border-bottom trustee-row"
      >

        <!-- Trustee Info -->
        <div class="col-md-5 d-flex align-items-center text-xs">
          <div class="avatar-circle me-3">
            {{ trustee.initials }}
          </div>
          <div>
            <div class="fw-semibold">{{ trustee.name }}</div>
            <small class="text-success">Active</small>
          </div>
        </div>

        <!-- Role -->
        <div class="col-md-4">
          <span
            class="status-badge rounded-pill px-3 py-2 border"
            :class="role_badge_class(trustee.role)"
          >
            {{ trustee.role }}
          </span>
        </div>

        <!-- Appointed -->
        <div class="col-md-3 text-xs">
          <i class="bx bx-calendar me-2 text-muted"></i>
          {{ trustee.appointed }}
        </div>

      </div>

    </div>

  </div>